export default {"src":"/_next/static/media/unesco.6a5768cf.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};